import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { CascadeLevel } from './cascade-level.resource';
import { Country } from './country.resource';
import { Fee } from './fee.resource';

@Resource({
  type: 'cascades',
})
export class Cascade extends AtomResource {
  @Attribute() name?: string;

  @Relationship() country?: Country;
  @Relationship() cascadelevels?: CascadeLevel[];

  get fees(): Fee[] {
    const levels = this.cascadelevels;

    if (!levels) {
      return [];
    }
    return levels.reduce(
      (fees, level) => fees.concat(level.fee || []),
      [] as Fee[]
    );
  }
}
